import { render, staticRenderFns } from "./OfferSetupReview.vue?vue&type=template&id=4735e592&scoped=true&lang=pug&"
import script from "./OfferSetupReview.vue?vue&type=script&lang=js&"
export * from "./OfferSetupReview.vue?vue&type=script&lang=js&"
import style0 from "./OfferSetupReview.vue?vue&type=style&index=0&id=4735e592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4735e592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VChip,VCol,VDivider,VIcon,VRow,VSimpleTable,VSpacer})
